(() => {
  document.querySelectorAll('#contact-form, [data-contact-form]').forEach((form) => {
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('#contact-status, [data-contact-status]');
  const originalLabel = button.innerHTML;
  let pending = false;
  let previousPayload;
  let submissionId;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (pending || !form.reportValidity()) return;
    const fields = Object.fromEntries(new FormData(form));
    const serialized = JSON.stringify(fields);
    if (serialized !== previousPayload) {
      submissionId = crypto.randomUUID();
      previousPayload = serialized;
    }
    pending = true;
    button.disabled = true;
    button.textContent = 'Sending…';
    form.setAttribute('aria-busy', 'true');
    status.hidden = true;
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...fields, submissionId }),
        signal: AbortSignal.timeout(20000),
      });
      const result = await response.json();
      if (!response.ok || !result.ok) throw new Error(result.error || 'Unable to send your message right now. Please try again or email info@quromedical.co.za.');
      status.dataset.state = 'success';
      status.textContent = 'Thank you! Your message has been sent to the Quro Medical team.';
      form.reset();
      previousPayload = undefined;
    } catch (error) {
      status.dataset.state = 'error';
      status.textContent = error instanceof SyntaxError || error.name === 'TypeError' || error.name === 'TimeoutError'
        ? 'We couldn’t confirm your message was sent. Please try again or email info@quromedical.co.za.'
        : error.message;
    } finally {
      pending = false;
      button.disabled = false;
      button.innerHTML = originalLabel;
      form.removeAttribute('aria-busy');
      status.hidden = false;
      status.focus();
    }
  });
  });
})();
